/* eslint-disable react/no-invalid-html-attribute */
import Head from 'next/head'
import { type PageMetadataProps } from './PageMetadata.interface'
import { baseCdnUrl } from '~/features/infra/environment'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PageMetadata =
({ metadata, priorityImage, schema }: PageMetadataProps): JSX.Element => (
  <Head>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1"
      key="viewport"
    />

    <title>{metadata.title}</title>
    <meta name="description" content={metadata.description} />
    <meta name="keywords" content={metadata.keywords} />
    <link rel="canonical" href={metadata.canonical} />

    <link rel="preconnect" href="https://www.googletagmanager.com" />
    <link rel="preconnect" href="https://region1.google-analytics.com" />
    {baseCdnUrl && <link rel="preconnect" href={baseCdnUrl} />}
    <link rel="dns-prefetch" href="https://www.googletagmanager.com" />
    <link rel="dns-prefetch" href="https://region1.google-analytics.com" />
    {baseCdnUrl && <link rel="dns-prefetch" href={baseCdnUrl} />}

    <link rel="preload" href="https://use.typekit.net/ylh8tkz.css" />

    {metadata.openGraph?.title && (
      <meta
        property="og:title"
        content={metadata.openGraph.title}
        key="ogTitle"
      />
    )}

    {metadata.openGraph?.image && (
      <>
        <meta
          property="og:image"
          content={metadata.openGraph.image.src}
          key="ogImgUrl"
        />

        {metadata.openGraph.image.width && (
        <meta
          property="og:image:width"
          content={metadata.openGraph.image.width.toString()}
          key="ogImgWidth"
        />
        )}

        {metadata.openGraph.image.height && (
        <meta
          property="og:image:height"
          content={metadata.openGraph.image.height.toString()}
          key="ogImgHeight"
        />
        )}

        {metadata.openGraph.image.alt && (
        <meta
          property="og:image:alt"
          content={metadata.openGraph.image.alt}
          key="ogImgAlt"
        />
        )}
      </>
    )}

    {metadata.openGraph?.url && (
      <meta property="og:url" content={metadata.openGraph.url} key="ogUrl" />
    )}

    {metadata.openGraph?.description && (
      <meta
        property="og:description"
        content={metadata.openGraph.description}
        key="ogDescription"
      />
    )}

    <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
    <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
    <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
    <link rel="manifest" href="/site.webmanifest" />
    <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
    <meta name="msapplication-TileColor" content="#da532c" />
    <meta name="theme-color" content="#ffffff" />

    {priorityImage && (
      <link rel="preload" as="image" href={priorityImage} />
    )}

    {schema && (
      // eslint-disable-next-line react/no-danger
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
    )}
  </Head>
)
